'use client';

import { useTheme } from '../context/ThemeProvider';
import { useLocale } from '../context/DynamicLocaleProvider';
import styles from './LocalLLMTrust.module.css';

interface LocalLLMTrustProps {
  /** Optional custom text. Defaults to trust message about local LLM. */
  text?: React.ReactNode;
  /** Optional class name for the root element */
  className?: string;
}

export default function LocalLLMTrust({ text, className }: LocalLLMTrustProps) {
  const { theme } = useTheme();
  const { t } = useLocale();
  const isDark = theme === 'dark';
  const logoSrc = isDark ? '/assets/identity/logo-dark.svg' : '/assets/identity/logo.svg';
  const shieldSrc = isDark ? '/assets/icons/shield.fill.svg' : '/assets/icons/shield.fill.black.svg';

  const defaultText = (
    <>
      <strong>{t('local_llm_trust_label')}</strong>
      {t('local_llm_trust_suffix')}
    </>
  );
  const displayText = text ?? defaultText;

  return (
    <div className={className ? `${styles.root} ${className}` : styles.root} role="status" aria-label={t('local_llm_trust_aria')}>
      <img
        src={shieldSrc}
        alt=""
        className={styles.icon}
        width={24}
        height={24}
      />
      <img
        src={logoSrc}
        alt=""
        className={styles.logo}
        width={20}
        height={20}
      />
      <p className={styles.text}>{displayText}</p>
    </div>
  );
}
